// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#nwvw :root {
  --primary-color: #007bc7;
  --link-color: #007bc7;
  --link-color-hover: #00629e;
  --link-color-visited: #848;
}
#nwvw html {
  overflow: auto;
}
#nwvw .component-wrapper {
  position: relative;
}
#nwvw .content-small-wrapper {
  max-width: 600px;
}
#nwvw [class*=QuestionArea_container] {
  padding-bottom: 32px;
  border-bottom: 3px solid var(--primary-color);
}
#nwvw [class*=QuestionArea_form] {
  background: #fff;
  padding: 16px 0;
}
#nwvw [class*=InputRadioButtons_optionWrapper] {
  margin-left: 4px;
}
#nwvw [class*=Fieldset_fieldset] {
  border: none;
  margin-bottom: 32px;
  width: 100%;
}
#nwvw [class*=Fieldset_legend] {
  display: inline-grid;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: 700;
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: inherit;
  max-width: 100%;
  white-space: normal;
  font-size: 2.4rem;
}
@media (min-width: 720px) {
  #nwvw [class*=Fieldset_legend] {
    font-size: 2.8rem;
  }
}
#nwvw .Fieldset_helpText {
  display: block;
  margin: 8px 0;
}
#nwvw .Fieldset_helpText a {
  color: var(--link-color) !important;
}
#nwvw .Fieldset_helpText a:visited {
  color: var(--link-color-visited) !important;
}
#nwvw .Fieldset_helpText a:hover {
  color: var(--link-color-hover) !important;
}
#nwvw .QuestionArea_buttonArea {
  display: flex;
  justify-content: space-between;
}
#nwvw .QuestionArea_pullRight {
  margin-left: auto;
}
#nwvw .ResultsArea_buttonWrapper, #nwvw .ResultsArea_buttonArea {
  align-items: flex-end;
  border-top: 1px solid var(--primary-color);
  border-bottom: 3px solid var(--primary-color);
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 32px 0;
}
@media (min-width: 720px) {
  #nwvw .ResultsArea_buttonWrapper, #nwvw .ResultsArea_buttonArea {
    flex-direction: row;
    justify-content: flex-end;
  }
}
#nwvw [class*=ProgressBar_wrapper] .sr-only {
  display: none;
}
#nwvw [class*=ProgressBar_wrapper] [class*=ProgressBar_progress] {
  appearance: none;
  display: block;
  height: 8px;
  width: 100%;
  outline: 1px solid var(--primary-color);
  border: none;
  border-radius: 4px;
  overflow: hidden;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: #fff;
  margin-left: 0;
}
#nwvw [class*=ProgressBar_wrapper] [class*=ProgressBar_progress]::-webkit-progress-bar {
  background-color: #fff;
}
#nwvw .resultsOverview {
  border-top: 1px solid var(--primary-color);
  padding-top: 22px;
}
#nwvw .resultsOverview .title {
  font-weight: 700;
  font-size: 2rem;
}
#nwvw table.results {
  text-align: left;
  border-spacing: 0 16px;
  font-size: 2rem;
}
#nwvw table.results th,
#nwvw table.results td {
  vertical-align: top;
}
#nwvw table.results td:first-child {
  padding-right: 20px;
}
#nwvw .sr-only {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
#nwvw .loader-wrapper {
  display: flex;
  justify-content: center;
  max-width: 600px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
#nwvw .loader svg {
  color: var(--primary-color);
  animation: spin 1s linear infinite;
  flex: none;
  width: 2rem;
  height: 2rem;
  display: block;
  vertical-align: middle;
}
#nwvw .loader circle {
  opacity: 0.25;
}
#nwvw .loader path {
  opacity: 0.75;
}
#nwvw .hidden {
  visibility: hidden;
  display: none;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
#nwvw .collapse-container {
  padding: 16px 0 0;
}
#nwvw .collapse .header {
  margin: 0;
  padding: 16px 0;
  position: relative;
  word-break: normal;
}
#nwvw .collapse .header:before {
  border-top: 1px solid var(--primary-color);
  content: "";
  display: block;
  left: 0;
  position: absolute;
  top: 0;
  width: 100px;
}
#nwvw .collapse .header .icon {
  margin-left: -4px;
  margin-top: 4px;
  min-width: 20px;
}
#nwvw .collapse .header .icon path {
  fill: var(--button-color);
}
#nwvw .collapse .header .collapse-header {
  align-items: flex-start;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  font-weight: 700;
  outline: none;
  padding: 0 0 3px;
  text-align: left;
}
#nwvw .collapse .header .collapse-header:focus {
  background: var(--focus-color);
  border-bottom: 3px solid #000;
  color: #000;
  outline: none;
  padding-bottom: 0;
  z-index: 2000;
}
#nwvw .collapse .header .collapse-header:focus path {
  fill: #000;
}
#nwvw .collapse .header .collapse-header .text {
  color: #000;
  font-size: 2rem;
  margin-left: 16px;
}
#nwvw .collapse .header .collapse-header .text.small {
  font-size: 1.8rem;
}
#nwvw .collapse .panel {
  overflow: hidden;
  word-break: normal;
}
#nwvw .collapse .panel .panelContent {
  margin-bottom: 32px;
  margin-left: 32px;
}
#nwvw .collapse .panel .panelContent h3, #nwvw .collapse .panel .panelContent h4, #nwvw .collapse .panel .panelContent h5, #nwvw .collapse .panel .panelContent h6 {
  font-size: 1.8rem;
  line-height: 1.3333;
  margin-bottom: 3px;
  margin-top: 24px;
}
#nwvw .collapse .panel .panelContent h3 a, #nwvw .collapse .panel .panelContent h4 a, #nwvw .collapse .panel .panelContent h5 a, #nwvw .collapse .panel .panelContent h6 a {
  padding-bottom: 0;
}
#nwvw .collapse .panel .panelContent h3:first-child, #nwvw .collapse .panel .panelContent h4:first-child, #nwvw .collapse .panel .panelContent h5:first-child, #nwvw .collapse .panel .panelContent h6:first-child {
  margin-top: 0;
}
#nwvw .collapse .panel .panelContent h4, #nwvw .collapse .panel .panelContent h5, #nwvw .collapse .panel .panelContent h6 {
  font-style: italic;
}

:global([dir=rtl]) #nwvw .collapse .header:before {
  right: 0;
}
:global([dir=rtl]) #nwvw .collapse .header .icon {
  margin-left: 0;
  margin-right: -4px;
}
:global([dir=rtl]) #nwvw .collapse .header .collapse-header .text {
  margin-left: 0;
  margin-right: 16px;
}
:global([dir=rtl]) #nwvw .collapse .panel .panelContent {
  margin-left: 0;
  margin-right: 32px;
}

@media (min-width: 720px) {
  #nwvw .collapse .header .collapse-header .text {
    font-size: 2.4rem;
  }
  #nwvw .collapse .header .collapse-header .text.small {
    font-size: 2rem;
  }
  #nwvw .collapse .panel .panelContent h3, #nwvw .collapse .panel .panelContent h4, #nwvw .collapse .panel .panelContent h5, #nwvw .collapse .panel .panelContent h6 {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/App.scss"],"names":[],"mappings":"AAGI;EACI,wBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;AAFR;AAKI;EACI,cAAA;AAHR;AAUI;EACI,kBAAA;AARR;AAWI;EACI,gBAAA;AATR;AAYI;EACI,oBAAA;EACA,6CAAA;AAVR;AAaI;EACI,gBAAA;EACA,eAAA;AAXR;AAcI;EACI,gBAAA;AAZR;AAmBI;EACI,YAAA;EACA,mBAAA;EACA,WAAA;AAjBR;AAoBI;EACI,oBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAlBR;AAoBQ;EAdJ;IAeQ,iBAAA;EAjBV;AACF;AAoBI;EACI,cAAA;EACA,aAAA;AAlBR;AAoBQ;EACI,mCAAA;AAlBZ;AAoBY;EACI,2CAAA;AAlBhB;AAqBY;EACI,yCAAA;AAnBhB;AA2BI;EACI,aAAA;EACA,8BAAA;AAzBR;AA4BI;EACI,iBAAA;AA1BR;AA6BI;EACI,qBAAA;EACA,0CAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA3BR;AA6BQ;EAVJ;IAWQ,mBAAA;IACA,yBAAA;EA1BV;AACF;AAkCQ;EACI,aAAA;AAhCZ;AAmCQ;EAGI,gBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,sBAAA;EACA,cAAA;AAjCZ;AAmCY;EACI,sBAAA;AAjChB;AA0CI;EACI,0CAAA;EACA,iBAAA;AAxCR;AA0CQ;EACI,gBAAA;EACA,eAAA;AAxCZ;AA4CI;EACI,gBAAA;EACA,sBAAA;EACA,eAAA;AA1CR;AA6CI;;EAEI,mBAAA;AA3CR;AA8CI;EACI,mBAAA;AA5CR;AAoDI;EACI,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAlDR;AAyDI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AAvDR;AA2DQ;EACI,2BAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAzDZ;AA4DQ;EACI,aAAA;AA1DZ;AA6DQ;EACI,aAAA;AA3DZ;AA+DI;EACI,kBAAA;EACA,aAAA;AA7DR;AAgEI;EACI;IACI,yBAAA;EA9DV;AACF;AAiEI;EACI,iBAAA;AA/DR;AAmEQ;EACI,SAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAjEZ;AAmEY;EACI,0CAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;AAjEhB;AAoEY;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AAlEhB;AAoEgB;EACI,yBAAA;AAlEpB;AAsEY;EACI,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AApEhB;AAsEgB;EACI,8BAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AApEpB;AAsEoB;EACI,UAAA;AApExB;AAwEgB;EACI,WAAA;EACA,eAAA;EACA,iBAAA;AAtEpB;AAyEgB;EACI,iBAAA;AAvEpB;AA4EQ;EACI,gBAAA;EACA,kBAAA;AA1EZ;AA4EY;EACI,mBAAA;EACA,iBAAA;AA1EhB;AA4EgB;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA1EpB;AA4EoB;EACI,iBAAA;AA1ExB;AA6EoB;EACI,aAAA;AA3ExB;AA+EgB;EACI,kBAAA;AA7EpB;;AAwFgB;EACI,QAAA;AArFpB;AAwFgB;EACI,cAAA;EACA,kBAAA;AAtFpB;AA0FoB;EACI,cAAA;EACA,kBAAA;AAxFxB;AA8FgB;EACI,cAAA;EACA,kBAAA;AA5FpB;;AAmGA;EAKoB;IACI,iBAAA;EApGtB;EAuGkB;IACI,eAAA;EArGtB;EA4GkB;IACI,eAAA;EA1GtB;AACF","sourcesContent":["// App styling\n// -----------------------\n#nwvw {\n    :root {\n        --primary-color: #007bc7;\n        --link-color: #007bc7;\n        --link-color-hover: #00629e;\n        --link-color-visited: #848;\n    }\n\n    html {\n        overflow: auto;\n    }\n\n\n    // Wrapper\n    // -----------------------\n\n    .component-wrapper {\n        position: relative;\n    }\n\n    .content-small-wrapper {\n        max-width: 600px;\n    }\n\n    [class*='QuestionArea_container'] {\n        padding-bottom: 32px;\n        border-bottom: 3px solid var(--primary-color);\n    }\n\n    [class*='QuestionArea_form'] {\n        background: #fff;\n        padding: 16px 0;\n    }\n\n    [class*='InputRadioButtons_optionWrapper'] {\n        margin-left: 4px;\n    }\n\n\n    // Fieldset\n    // -----------------------\n\n    [class*='Fieldset_fieldset'] {\n        border: none;\n        margin-bottom: 32px;\n        width: 100%;\n    }\n\n    [class*='Fieldset_legend'] {\n        display: inline-grid;\n        justify-content: space-between;\n        align-items: flex-start;\n        font-weight: 700;\n        width: 100%;\n        margin: 0;\n        padding: 0;\n        box-sizing: border-box;\n        color: inherit;\n        max-width: 100%;\n        white-space: normal;\n        font-size: 2.4rem;\n\n        @media(min-width: 720px) {\n            font-size: 2.8rem\n        }\n    }\n\n    .Fieldset_helpText {\n        display: block;\n        margin: 8px 0;\n\n        a {\n            color: var(--link-color) !important;\n\n            &:visited {\n                color: var(--link-color-visited) !important;\n            }\n\n            &:hover {\n                color: var(--link-color-hover) !important;\n            }\n        }\n    }\n\n    // Button group\n    // -----------------------\n\n    .QuestionArea_buttonArea {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .QuestionArea_pullRight {\n        margin-left: auto;\n    }\n\n    .ResultsArea_buttonWrapper, .ResultsArea_buttonArea {\n        align-items: flex-end;\n        border-top: 1px solid var(--primary-color);\n        border-bottom: 3px solid var(--primary-color);\n        display: flex;\n        flex-direction: column;\n        margin-top: 16px;\n        margin-bottom: 16px;\n        padding: 32px 0;\n\n        @media (min-width: 720px) {\n            flex-direction: row;\n            justify-content: flex-end;\n        }\n    }\n\n\n    // Progressbar\n    // -----------------------\n\n    [class*='ProgressBar_wrapper'] {\n        .sr-only {\n            display: none;\n        }\n\n        [class*='ProgressBar_progress'] {\n            -webkit-appearance: none;\n            -moz-appearance: none;\n            appearance: none;\n            display: block;\n            height: 8px;\n            width: 100%;\n            outline: 1px solid var(--primary-color);\n            border: none;\n            border-radius: 4px;\n            overflow: hidden;\n            transition: width .8s cubic-bezier(.4, 0, .2, 1);\n            background-color: #fff;\n            margin-left: 0;\n\n            &::-webkit-progress-bar {\n                background-color: #fff;\n            }\n        }\n    }\n\n\n    // Result table\n    // -----------------------\n\n    .resultsOverview {\n        border-top: 1px solid var(--primary-color);\n        padding-top: 22px;\n\n        .title {\n            font-weight: 700;\n            font-size: 2rem;\n        }\n    }\n\n    table.results {\n        text-align: left;\n        border-spacing: 0 16px;\n        font-size: 2rem;\n    }\n\n    table.results th,\n    table.results td {\n        vertical-align: top;\n    }\n\n    table.results td:first-child {\n        padding-right: 20px;\n    }\n\n\n    // Screenreader\n    // -----------------------\n\n    // TODO: Remove\n    .sr-only {\n        border: 0;\n        clip: rect(0 0 0 0);\n        height: 1px;\n        margin: -1px;\n        overflow: hidden;\n        padding: 0;\n        position: absolute;\n        width: 1px;\n    }\n\n\n    // Loader\n    // -----------------------\n\n    .loader-wrapper {\n        display: flex;\n        justify-content: center;\n        max-width: 600px;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n    }\n\n    .loader {\n        svg {\n            color: var(--primary-color);\n            animation: spin 1s linear infinite;\n            flex: none;\n            width: 2rem;\n            height: 2rem;\n            display: block;\n            vertical-align: middle;\n        }\n\n        circle {\n            opacity: 0.25;\n        }\n\n        path {\n            opacity: 0.75;\n        }\n    }\n\n    .hidden {\n        visibility: hidden;\n        display: none;\n    }\n\n    @keyframes spin {\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n\n    .collapse-container {\n        padding: 16px 0 0;\n    }\n\n    .collapse {\n        .header {\n            margin: 0;\n            padding: 16px 0;\n            position: relative;\n            word-break: normal;\n\n            &:before {\n                border-top: 1px solid var(--primary-color);\n                content: \"\";\n                display: block;\n                left: 0;\n                position: absolute;\n                top: 0;\n                width: 100px;\n            }\n\n            .icon {\n                margin-left: -4px;\n                margin-top: 4px;\n                min-width: 20px;\n\n                path {\n                    fill: var(--button-color);\n                }\n            }\n\n            .collapse-header {\n                align-items: flex-start;\n                background: none;\n                border: none;\n                cursor: pointer;\n                display: flex;\n                font-weight: 700;\n                outline: none;\n                padding: 0 0 3px;\n                text-align: left;\n\n                &:focus {\n                    background: var(--focus-color);\n                    border-bottom: 3px solid #000;\n                    color: #000;\n                    outline: none;\n                    padding-bottom: 0;\n                    z-index: 2000;\n\n                    path {\n                        fill: #000;\n                    }\n                }\n\n                .text {\n                    color: #000;\n                    font-size: 2rem;\n                    margin-left: 16px;\n                }\n\n                .text.small {\n                    font-size: 1.8rem;\n                }\n            }\n        }\n\n        .panel {\n            overflow: hidden;\n            word-break: normal;\n\n            .panelContent {\n                margin-bottom: 32px;\n                margin-left: 32px;\n\n                h3, h4, h5, h6  {\n                    font-size: 1.8rem;\n                    line-height: 1.3333;\n                    margin-bottom: 3px;\n                    margin-top: 24px;\n\n                    a {\n                        padding-bottom: 0;\n                    }\n\n                    &:first-child {\n                        margin-top: 0;\n                    }\n                }\n\n                h4, h5, h6 {\n                    font-style: italic;\n                }\n            }\n        }\n    }\n}\n\n:global([dir=rtl]) {\n    #nwvw {\n        .collapse {\n            .header {\n                &:before {\n                    right: 0;\n                }\n\n                .icon {\n                    margin-left: 0;\n                    margin-right: -4px;\n                }\n\n                .collapse-header {\n                    .text {\n                        margin-left: 0;\n                        margin-right: 16px;\n                    }\n                }\n            }\n\n            .panel {\n                .panelContent {\n                    margin-left: 0;\n                    margin-right: 32px;\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 720px) {\n    #nwvw {\n        .collapse {\n            .header {\n                .collapse-header {\n                    .text {\n                        font-size: 2.4rem;\n                    }\n\n                    .text.small {\n                        font-size: 2rem;\n                    }\n                }\n            }\n\n            .panel {\n                .panelContent {\n                    h3, h4, h5, h6  {\n                        font-size: 2rem;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
